// //2026/2/4 室内窓LP対応で新規作成　担当：四方
// //横幅max表示のスライダー

(function() {
  'use strict';

  // 「data-peek-slider」 かつ 「data-mode="marquee"」 を持ってる要素すべてを取得
  const sliders = document.querySelectorAll('[data-peek-slider][data-mode="marquee"]');
  // 取得した要素を1つずつ初期化
  sliders.forEach(initMarquee);

  function initMarquee(root) {
    // スライドを横並びにして動かすコンテナ
    const track  = root.querySelector('.peek-slider__track');
    // 各スライド（画像1枚分）の配列
    const slides = Array.from(root.querySelectorAll('.peek-slider__slide'));

    // trackが無い、またはスライドが1枚以下の場合は何もしない
    if (!track || slides.length === 0) return;

    // HTMLで書いているdeta属性を読み込む
    const peek = parseInt(root.dataset.peek || '0', 10);
    const gap  = parseInt(root.dataset.gap  || '0', 10);
    root.style.setProperty('--peek', peek + 'px');
    root.style.setProperty('--gap',  gap  + 'px');


    // ✅ スライドを丸ごとコピーして後ろに移動
    // DOMに影響を与えない一時的な箱を作る
    const fragment = document.createDocumentFragment();
    // スライドをすべてコピー
    slides.forEach(s => fragment.appendChild(s.cloneNode(true)));
    // コピーしたスライドをすべてまとめて後ろに追加
    track.appendChild(fragment);


    // ✅ スライド1周分の正確な横幅を計算
    function measureTrackWidth() {
      // オリジナル分のスライドだけ取り出す
      const originals = Array.from(track.children).slice(0, slides.length);

      let width = 0;
      // 各スライド（画像1枚分）の横幅の合計を求める
      originals.forEach(el => {
        width += el.getBoundingClientRect().width;
      });

      // gap補正（スライド間に隙間がある場合、それも足す）
      const style = getComputedStyle(track);
      const gapSize = parseInt(style.gap || style.columnGap || 0, 10);
      width += gapSize * (originals.length - 1);

      // 正確な横幅の合計を返す
      return width;
    }


    // ✅ スライドの移動距離と速度を計算して、アニメーションを起動
    function applyMarquee() {
      // スライド1周分の正確な横幅を取得
      const oneLoopWidth = measureTrackWidth();

      // 1周分の横幅が取得出来ていない場合、次の描画タイミングで再実行
      // →画像が読み込まれていない場合を想定
      if (!oneLoopWidth) {
        requestAnimationFrame(applyMarquee);
        return;
      }

      const pxPerSec = parseInt(root.dataset.speed || '50', 10); // 50px/秒で動く
      const duration = oneLoopWidth / pxPerSec; //1周分をpxPerSecの速さで動くと何秒かかるかを計算

      // CSSに値を渡す
      root.style.setProperty('--marquee-duration', duration + 's');    //何秒で1周するか
      root.style.setProperty('--marquee-end', (-oneLoopWidth) + 'px'); //どこまで移動するか

      // アニメーション開始
      root.classList.add('peek-slider--marquee');
    }

    // スライド画像をすべて取得
    const imgs = root.querySelectorAll('img');
    // ロード待ちの残り枚数カウント
    let pending = imgs.length;

    // 残り枚数0の場合、アニメーション起動
    if (pending === 0) {
      applyMarquee();
    // それ以外の場合
    } else {
      // 1枚ずつ確認
      imgs.forEach(img => {
        // 既にロード済みの場合
        if (img.complete) {
          // ロード待ちの残り枚数が0であれば、アニメーション起動
          if (--pending === 0) applyMarquee();
        // まだ読み込まれていない場合
        } else {
          // ロード完了まで待機
          img.addEventListener('load', () => {
            // ロード待ちの残り枚数が0であれば、アニメーション起動
            if (--pending === 0) applyMarquee();

          // イベント実行は1回だけ
          }, { once: true });
        }
      });
    }

    // ✅ 画面リサイズ時に幅を再計算してズレを防止
    let timer = null; // 自動再生用タイマーID
    
    // 画面サイズが変更されたときに実行
    window.addEventListener('resize', () => {
      // スライダーが有効でなければ何もしない
      // →初期化前の実行を防ぎ、無駄な処理を減らす
      if (!root.classList.contains('peek-slider--marquee')) return;
      // 既存のタイマーをキャンセル
      clearTimeout(timer);
      // 120秒後に再計算
      timer = setTimeout(applyMarquee, 120);
    });
  }
})();